import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { PublicLayout } from "../PublicLayout";

const stepMap = {
  servico: "Etapa 1/3",
  dia: "Etapa 2/3",
  horario: "Etapa 3/3",
};

const getStep = (pathname) => {
  const segments = pathname.split("/");
  for (let i = segments.length - 1; i >= 0; i--) {
    if (stepMap[segments[i]]) return stepMap[segments[i]];
  }
  return "";
};

export const PublicStepLayout = () => {
  const location = useLocation();
  const headerRight = getStep(location.pathname);

  return (
    <PublicLayout headerRight={headerRight}>
      <Outlet />
    </PublicLayout>
  );
};
